import React from 'react';
import useTranslate from '../../../../customHooks/useTranslate';
import {
    useZitoneoHotelRooms,
    useZitoneoServices,
} from '../../contexts/ZitoneoContentContext';
import { useZitoneoUI } from '../../contexts/ZitoneoUIContext';
import ZitoneoServicesList from './zitoneoHotelServices/ZitoneoServicesList';

const RoomServices = () => {
    const translate = useTranslate();
    const { rooms } = useZitoneoHotelRooms();
    const {
        selectedRoomId,
        idVisibleServicesDetail,
        handleVisibleServicesDetail,
    } = useZitoneoUI();
    const { selectedCategory, ComplementaryServiceTypes, languages } =
        useZitoneoServices();
    const room = rooms.find(roomItem => roomItem.Id === selectedRoomId);

    if (!room) {
        return <p>{translate('no_rooms_available')}</p>;
    }

    return (
        <ZitoneoServicesList
            title={
                selectedCategory ? selectedCategory.Name : 'your_hotel_services'
            }
            subtitle={selectedCategory ? selectedCategory.Description : ''}
            overtitle={
                selectedCategory ? selectedCategory.Name : 'your_hotel_services'
            }
            serviceTypes={
                selectedCategory
                    ? ComplementaryServiceTypes.filter(
                          service =>
                              service.IdServiceCategory ===
                              parseInt(selectedCategory.Id)
                      )
                    : ComplementaryServiceTypes
            }
            selectedServices={room.Services}
            selectedCategory={selectedCategory}
            onAddService={() => undefined}
            onVisibleServicesDetail={handleVisibleServicesDetail}
            idVisibleServicesDetail={idVisibleServicesDetail}
            languages={languages}
            roomId={room.Id}
        />
    );
};

export default RoomServices;
